import moment from "moment";
import React, { Component } from "react";
import Api from "../../../../Services/Api";
import { fetchDataAsync, getUserAccess } from "../../../../Services/Utils";
import SimpleDataTable from "../../../../modules/SimpleDataTable";
import { defaultTableChange } from "../../../../modules/custom/customTable";
import { HttpStatus } from "../../../common/Constants";
import { mapToObjectDDL, removeNullFields } from "../../../common/mapper";
import FakturJualBengkelSearch from "../components/fakturJualBengkelSearch";
import { INITIAL_PAGINATION, INITIAL_SEARCH_DATA_DGI } from "../constant";
import { getTableConfigDGI } from "./config";
import FakturJualBengkelDGIFilter from "./fakturJualBengkelDGIFilter";
import FakturJualBengkelDetail from "../components/fakturJualBengkelDetail";
import SimpleLoadingOverlay from "../../../../modules/popup/SimpleLoadingOverlay";

class FakturJualBengkelDGI extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      filterVisible: false,
      detailVisible: false,
      selectedData: null,
      isEditable: false,
      submittedFilterData: null,
      searchData: INITIAL_SEARCH_DATA_DGI,
      skipNextPaginationFetch: false,
      cabangOptions: [],
      mdOptions: [],
      mainDealer: null,
      dataTable: [],
      pagination: INITIAL_PAGINATION,
      userAccess: null,
      isCanConfirm: false,
      activityType: null,
    };
  }

  componentDidMount = () => {
    this.fetchMainDealer();
  };

  componentDidUpdate(prevProps, prevState) {

    const currPagination = this.state.pagination;
    const prevPagination = prevState.pagination;


    let filter = this.state.searchData

    if(this.state.submittedFilterData!==null){
      filter = {
        ...this.state.submittedFilterData
      }
    }

    if (
      (currPagination.page !== prevPagination.page ||
        currPagination.limit !== prevPagination.limit) &&
      !this.state.skipNextFetch
    ) {
      this.fetchData(
        removeNullFields({ ...filter }),
        currPagination.limit,
        currPagination.page
      );
    }

    if(this.state.skipNextFetch){
      this.setState({
        skipNextFetch: false
      })
    }
  }

  fetchMainDealer = async () => {
    const { menuAccess, setError } = this.props;

    this.handleTriggerLoading();

    const kodeCabang = menuAccess.map((data) => data.idRefObj);
    const res = await fetchDataAsync({
      asyncFn: Api.create("NAGAMAS_MASTER_DATA").getMainDealerForSalesOrderDGI,
      setError: setError,
      menuName: "Faktur Jual Bengkel - DGI",
      args: {
        kodeCabang: kodeCabang,
      },
    });

    if (res.ok && res.data.status === HttpStatus.SUCCESS) {
      const { data } = res.data;
      const listMd = data.map((item) => {
        const commonCabang = item.kodeCabang.filter((i) =>
          kodeCabang.includes(i)
        );
        return {
          value: item.supplierCode,
          label: item.supplierName,
          kodeCabang: commonCabang,
          ahmDealerCode: item.ahmDealerCode,
        };
      });

      if (listMd.length > 0) {
        this.setState((prevState) => ({
          ...prevState,
          mdOptions: listMd,
          mainDealer: listMd[0],
          userAccess: getUserAccess(
            this.props.menuAccess,
            listMd[0]?.kodeCabang[0] || null
          ),
          searchData:{
            ...prevState.searchData,
            dealerAhm: listMd[0]?.ahmDealerCode,
          }
        }), () => {
          this.fetchData({ ...this.state.searchData }, 5, 1);
        });
      }
    }

    this.handleTriggerLoading();
  };

  fetchData = async (filter = {}, limit, page) => {
    const { setError } = this.props;
    const { mainDealer } = this.state;

    this.handleTriggerLoading();
    const res = await fetchDataAsync({
      asyncFn: Api.create("NAGAMAS_DGI").getFJBgiMainPage,
      menuName: "Faktur Jual Bengkel - DGI",
      setError: setError,
      args: {
        ...filter,
        // dealerAhm: mainDealer?.ahmDealerCode,
        limit: limit,
        page: page,
      },
    });
    this.handleTriggerLoading();

    if (res.ok && res.data.status === HttpStatus.SUCCESS) {
      this.setState((prev) => ({
        ...prev,
        dataTable: res.data.data || [],
        pagination: {
          ...prev.pagination,
          totalData: res.data.totalData,
        },
      }));
    }
  };

  handleTriggerLoading = () => {
    this.setState((prevValue) => ({
      ...prevValue,
      loading: !prevValue.loading,
    }));
  };

  handleClickSearch = async () => {
    const { mainDealer, mdOptions, searchData, pagination } = this.state;

    this.setState((prevValue) => ({
      ...prevValue,
      submittedFilterData: null,
      pagination: {
        ...prevValue.pagination,
        page: 1,
      },
      skipNextFetch: true,
    }));

    const md = mainDealer || mdOptions[0];

    const request = removeNullFields({
      dealerAhm: md?.ahmDealerCode,
      startPeriod: searchData?.startPeriod || null,
      endPeriod: searchData?.endPeriod || null,
    });

    await this.fetchData(request, pagination.limit, 1);

    this.setState((prevValue) => ({
      ...prevValue,
      mainDealer: md,
      searchData: request,
    }));
  };

  handleModalFilterVisibility = () => {
    this.setState((prevValue) => ({
      ...prevValue,
      filterVisible: !prevValue.filterVisible,
    }));
  };

  handleValueChange = (name, value) => {
    this.setState((prevValue) => ({
      ...prevValue,
      searchData: {
        ...prevValue.searchData,
        [name]: moment(value, "DD-MM-YYYY").format("DD-MM-YYYY"),
      },
    }));
  };

  handleCabangChange = async (name, value) => {
    this.setState((prevValue) => ({
      ...prevValue,
      [name]: value,
      searchData: {
        dealerAhm: value?.ahmDealerCode,
        ...INITIAL_SEARCH_DATA_DGI,
      },
      skipNextPaginationFetch: true,
      userAccess: getUserAccess(this.props.menuAccess, value.kodeCabang[0]),
      pagination: INITIAL_PAGINATION,
    }),async()=>{
      this.fetchData({ ...this.state.searchData }, 5, 1);
    });
  };

  triggerGetFJDGI = async () => {
    const { searchData, mainDealer } = this.state;
    const { setError } = this.props;
    this.handleTriggerLoading();
    const res = await fetchDataAsync({
      asyncFn: Api.create("NAGAMAS_DGI").getFJBDgiManualy,
      menuName: "Faktur Jual Bengkel - DGI",
      setError,
      args: {
        kodeCabang: mainDealer?.kodeCabang,
        req: {
          dealerAhm: mainDealer?.ahmDealerCode || null,
          startPeriod: searchData?.startPeriod || null,
          endPeriod: searchData?.endPeriod || null,
          page: 1,
          limit: 5,
        },
      },
    });
    if (res.ok && res.data.status === HttpStatus.SUCCESS) {
      this.setState((prev) => ({
        ...prev,
        dataTable: res?.data?.data?.length > 0 ? res?.data?.data : [],
        skipNextPaginationFetch: true,
        pagination: {
          page: 1,
          limit: 5,
          totalData: res.data.totalData,
        },
      }));
    }
    this.handleTriggerLoading();
  };

  getTableColumns = () => {
    return getTableConfigDGI({
      userAccess: this.state.userAccess,
      onShowDetail: async (rowIndex, activity) => {
        await this.fetchDataCabang(rowIndex);
        this.handleShowDetail(rowIndex, activity);
      },
    });
  };

  handleShowDetail = (index, activityType) => {
    this.setState((prevValue) => ({
      ...prevValue,
      detailVisible: !prevValue.detailVisible,
      selectedData: this.state.dataTable[index],
      activityType: activityType,
    }));
  };

  handleChangePage = (tableState) => {
    this.setState((prevValue) => ({
      ...prevValue,
      pagination: {
        ...prevValue.pagination,
        page: tableState.page + 1,
      },
    }));
  };

  handleRowsPerPage = (tableState) => {
    this.setState((prevValue) => ({
      ...prevValue,
      pagination: {
        page: 1,
        totalData: 1,
        limit: tableState.rowsPerPage,
      },
    }));
  };

  handleStateChange = (callback) => {
    this.setState(callback);
  };

  handleSubmitFilter = (payload) => {
    this.setState((prev) => ({
      ...prev,
      submittedFilterData: payload,
      searchData: {
        ...prev.searchData,
        startPeriod: null,
        endPeriod: null,
      },
      pagination: {
        ...prev.pagination,
        page: 1,
      },
      skipNextFetch: true,
    }));

    this.fetchData(
      removeNullFields({
        ...payload,
        ...(payload.variantCode
          ? { variantCode: payload?.variantCode?.value }
          : {}),
        ...(payload.dealerAhm
          ? { dealerAhm: [payload?.dealerAhm?.value] }
          : {}),
        ...(payload.provinceId
          ? { provinceId: payload?.provinceId?.value }
          : {}),
        ...(payload.kabKotId ? { kabKotId: payload?.kabKotId?.value } : {}),
        ...(payload.kecamatanId
          ? { kecamatanId: payload?.kecamatanId?.value }
          : {}),
        ...(payload.kelurahanId
          ? { kelurahanId: payload?.kelurahanId?.value }
          : {}),
      }),
      this.state.pagination.limit,
      1
    );
  };

  fetchDataCabang = async (index) => {
    const { setError } = this.props;
    // const { mainDealer, dataTable } = this.state;
    // const id = dataTable[index]?.dealerId;
    this.handleTriggerLoading();
    let res = await fetchDataAsync({
      asyncFn: Api.create("NAGAMAS_MASTER_DATA").findAllMasterCabang,
      menuName: "Faktur Jual Bengkel - DGI",
      setError: setError,
      args: {
        // ahmDealerCode: id,
        // kodeCabang: mainDealer?.kodeCabang,
      },
    });
    this.handleTriggerLoading();
    if (res.ok && res.data.status === HttpStatus.SUCCESS) {
      // this.setState((prevState) => ({
      //   ...prevState,
      //   cabangOptions: res.data.data.map((c) =>
      //     mapToObjectDDL(c.namaDealer, c.kodeCabang)
      //   ),
      // }));
      let filteredData = res.data.data.filter(
        item => this.props.menuAccess.map(data => data.idRefObj).includes(item.kodeCabang)
      );
      if (filteredData.length !== 0) {
        this.setState((prevValue) => ({
          ...prevValue,
          cabangOptions: filteredData.map(item => mapToObjectDDL(item.namaDealer, item.kodeCabang)),
        }));
      }
    }
  };

  handleRefresh = () => {
    this.setState({
      skipNextFetch: true,
    });

    let filter = this.state.searchData;

    if (this.state.submittedFilterData !== null) {
      filter = {
        ...this.state.submittedFilterData,
      };
    }
    this.fetchData(
      removeNullFields({ ...filter }),
      this.state.pagination.limit,
      this.state.pagination.page,
    );
  };

  render() {
    const {
      dataTable,
      pagination,
      detailVisible,
      selectedData,
      activityType,
      filterVisible,
      loading,
      cabangOptions,
      submittedFilterData,
      mainDealer
    } = this.state;
    const { menuAccess } = this.props;
    return (
      <React.Fragment>
        <FakturJualBengkelSearch
          tab="DGI"
          state={this.state}
          onSubmit={this.handleClickSearch}
          onShowFilter={this.handleModalFilterVisibility}
          onValueChange={this.handleValueChange}
          onCabangChange={this.handleCabangChange}
          onManualGetDGIData={this.triggerGetFJDGI}
          menuAccess={menuAccess}
        />
        <SimpleDataTable
          data={dataTable}
          columns={this.getTableColumns()}
          toCount={pagination.totalData}
          rowsPerPage={pagination.limit}
          page={pagination.page - 1}
          options={defaultTableChange(
            this.handleChangePage,
            this.handleRowsPerPage
          )}
        />
        {filterVisible && (
          <FakturJualBengkelDGIFilter
            {...this.props}
            visible={filterVisible}
            kodeCabang={mainDealer?.kodeCabang}
            submittedFilterData={submittedFilterData}
            onClickClose={this.handleModalFilterVisibility}
            onSubmit={this.handleSubmitFilter}
            onTriggerLoading={this.handleTriggerLoading}
          />
        )}
        {detailVisible && (
          <FakturJualBengkelDetail
            {...this.props}
            tab="DGI"
            activityType={activityType}
            selectedData={selectedData}
            visible={detailVisible}
            onRefresh={this.handleRefresh}
            cabangOptions={cabangOptions}
            kodeCabang={cabangOptions[0]}
            onTriggerLoading={this.handleTriggerLoading}
            onClickClose={() => this.handleShowDetail()}
          />
        )}
        {loading && <SimpleLoadingOverlay active={loading} />}
      </React.Fragment>
    );
  }
}

export default FakturJualBengkelDGI;
